import React, { Component } from 'react'
import { IntlProvider, injectIntl, FormattedMessage } from 'react-intl'
import InputMask from 'react-input-mask'
import createAxios from 'utils/axios'

// Constants
import { DEFAULT_LOCALE, CHINA_REGION } from '../../dashboard/constants'

class Login extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: props.login || props.email,
      phone: props.login || props.phone || '86 ',
      mask: '99 999 9999 9999',
      password: '',
      message: '',
      fetching: false,
      disableBtn: false,
      component: 'Login'
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState({
      email: newProps.email,
      phone: newProps.phone ? `${newProps.phone}` : '86 '
    })
  }

  componentDidMount() {
    this.axios = createAxios({
      intl: this.props.intl
    })
  }

  t(id) {
    return this.props.intl.formatMessage({ id })
  }

  link(url) {
    const locale = (DEFAULT_LOCALE === this.props.locale) ? '' : `/${this.props.locale}`
    return `${locale}${url}`
  }

  changeEmail(e) {
    this.setState({ email: e.target.value })
  }

  changePhone(e) {
    let phone = e.target.value
    let mask = '99 999 9999 9999'

    if (phone.slice(0, 3) !== '86 ') {
      mask = ''
      phone = phone.replace(/_/g, '').replace(/\s/g, '')
    }

    this.setState({
      phone,
      mask
    })
  }

  changePassword(e) {
    this.setState({ password: e.target.value })
  }

  focusHandler() {
    this.setState({ message: '', disableBtn: false })
  }

  submitHandler(e) {
    e.preventDefault()

    this.setState({
      fetching: true,
      message: ''
    }, this.validate)
  }

  request() {
    const { email, phone } = this.state
    const { activationCode } = this.props

    const url = '/login'
    const payload = {
      email: email || phone.replace(/_/g, '').replace(/\s/g, ''),
      password: this.state.password
    }

    if (activationCode) {
      payload.activation_code = activationCode
    }

    this.axios.post(url, payload)
      .then(res => {
        const { data: { error } } = res

        if (error) {
          this.setState({ message: error })
        } else {
          const activation_code = res.data.activation_code
            ? `?activation_code=${res.data.activation_code}`
            : ''
          window.location = `/dashboard${activation_code}`
        }
      })
      .catch(data => {
        console.log('Login error:', data)
      })
      .then((data) => {
        this.setState({ disableBtn: false, fetching: false })
      })
  }

  validate(e) {
    this.setState({ fetching: true })
    const { email, phone, password } = this.state
    const { region } = this.props
    let valid = true

    if (region === CHINA_REGION && (this.validatePresence(phone) || phone === '86 ')) {
      valid = false
    } else if (region === 'global' && (this.validatePresence(email))) {
      valid = false
    } else if (this.validatePresence(password)) {
      valid = false
    }

    if (!valid) {
      this.setState({
        fetching: false,
        message: this.t('ActivationCode.FieldsAreRequired')
      })
    } else {
      this.setState({ disableBtn: true })
      this.request()
    }
  }

  validatePresence (value) {
    const re = /^\s+$/

    if (value.length === 0 || re.test(value)) {
      return true
    }
  }

  activationCodeHandler(e) {
    if (this.state.disableBtn) {
      e.preventDefault()
      return false
    }
    e.preventDefault()

    this.props.flashHandler(null)
    this.props.nextStep()
  }

  render() {
    const { locale, loginPath, region, activationCode } = this.props
    const {
      phone, email, password, message, fetching
    } = this.state

    return (
      <div className="login">
        <h3><FormattedMessage id="Login.Header" /></h3>

        <form
          onSubmit={this.submitHandler.bind(this)}
          method="POST" className="form"
        >
          { this.props.region === CHINA_REGION ?
            <div className="form-group form-group-icon">
              <InputMask
                type="text"
                name="phone"
                value={phone}
                onChange={this.changePhone.bind(this)}
                onFocus={this.focusHandler.bind(this)}
                placeholder={this.t('Common.Phone')}
                mask={this.state.mask}
                maskChar="_"
              />
              <i className="form-icon form-icon-phone"></i>
            </div>
          :
            <div className="form-group form-group-icon">
              <input
                type="text"
                name="email"
                value={email}
                onChange={this.changeEmail.bind(this)}
                onFocus={this.focusHandler.bind(this)}
                placeholder={this.t('Common.Email')}
              />
              <i className="form-icon form-icon-mail"></i>
            </div>
          }

          <div className="form-group form-group-icon">
            <input
              type="password"
              name="password"
              value={password}
              onChange={this.changePassword.bind(this)}
              onFocus={this.focusHandler.bind(this)}
              placeholder={this.t('Common.Password')}
            />
            <i className="form-icon form-icon-password"></i>
          </div>

          {activationCode && (
            <div>
              <p>{this.t('Common.ActivationCode')}</p>
              <div className="form-group form-group-icon activation-input-wrap">
                <input
                  type="text"
                  name="activationCode"
                  disabled
                  value={activationCode}
                />
                <i className="form-icon form-icon-password"></i>
              </div>
            </div>
          )}

          <div className="form__message">
            <small className="error">{ message.length > 0 && message }</small>
            { fetching &&
              <div className="wrapper">
                <div className="cssload-loader"></div>
              </div>
            }
          </div>

          <input
            type="submit"
            disabled={this.state.disableBtn}
            className="button button-dark-blue"
            value={this.t('Login.Login')}
          />

          <div>
            <div className="or"><FormattedMessage id="Login.Or" /></div>

            <a href='' className='button' onClick={this.activationCodeHandler.bind(this)}>
              <FormattedMessage id="Login.ActivateCard" />
            </a>
          </div>
        </form>

        <div className="login__links">
          <div>
            <a href={this.link('/forgot_password')}><FormattedMessage id="Login.ForgotPassword" /></a>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(Login)



// WEBPACK FOOTER //
// ./app/javascript/components/application/auth/login.js